export default __webpack_public_path__ + "static/media/app.bf27ca69.png";